import axios from 'axios';
import { store } from '@/store.js'; // Глобальне сховище даних
let baseURL = 'https://api.skyservice.online/'
let params = {
  baseURL: baseURL
}
if (process.env.NODE_ENV == 'production') {
  let host = window.location.host;
  let subdomain = host.split('.')[0];
  if(subdomain != "pos"){
    params.baseURL = 'https://'+ subdomain +'.api.skyservice.online';
  }
}
const axiosAuth = axios.create(params)

export class Auth {
  loginInCabinet(obj) {
    return axiosAuth.post(`https://api.auth.skyservice.online/?section=users&action=auth`, obj).then((response) => response.data);
  }
  getCompanies(token){
    return axiosAuth.get(`https://api.auth.skyservice.online/?section=company&action=getCompanies&token=${token}`).then(response => response.data);
  }
  getCompany(obj){
    return axiosAuth.post(`https://api.auth.skyservice.online/?section=users&action=redirect`, obj).then((response) => response.data);
  }
  logout() {
    return axiosAuth.post(`?section=workers&action=logoutWorker&${store.currentTradepoint}`);
  }
}
